"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreuiSidebarItem = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_router_dom_1 = require("react-router-dom");
const CoreuiSidebarItemComponent = (props) => {
    const { icon, children, url, onClick, exact } = props;
    return (react_1.default.createElement("li", { className: "nav-item" }, onClick ? (react_1.default.createElement("button", { type: "button", onClick: onClick, className: "btn btn-link nav-link" }, children)) : (react_1.default.createElement(react_router_dom_1.NavLink, { exact: exact, to: url, className: "nav-link", 
        // onClick is required to close sidebar on mobile when link is clicked
        onClick: () => document.getElementsByClassName('app')[0].classList.toggle('sidebar-show') },
        icon ? react_1.default.createElement("i", { className: icon }) : '',
        ` ${children}`))));
};
CoreuiSidebarItemComponent.propTypes = {
    children: prop_types_1.default.node.isRequired,
    url: prop_types_1.default.string,
    icon: prop_types_1.default.string,
    onClick: prop_types_1.default.func,
    exact: prop_types_1.default.bool,
};
CoreuiSidebarItemComponent.defaultProps = {
    exact: false,
    url: undefined,
    onClick: undefined,
    icon: '',
};
exports.CoreuiSidebarItem = CoreuiSidebarItemComponent;
//# sourceMappingURL=CoreuiSidebarItem.js.map